import React, { useState } from 'react';
import { IonModal, IonButton, IonIcon, IonSegment, IonSegmentButton, IonLabel } from '@ionic/react';
import { close, arrowBack } from 'ionicons/icons';
import Login from '../modals/forms/Login';
import Register from '../modals/forms/Register';
import Forgot from '../modals/forms/Forgot';
import './Auth.css';

interface Props {
    isLoginParentCallback: Function
}
const Auth = (props: Props) => {
    const [state, setState] = useState({
        showAuthModal: false,
        segValue: 'login',
        isForgot: false,
        isVerifyTemp: false,
        isForgotSubmit: true
    });
    const handleLoginForgotParentCallback = (childData: boolean) => {
        setState({ ...state, isForgot: childData });
    }
    const backToLogin = () => {
        setState({ ...state, segValue: 'login', isForgot: false })
    }
    const handleIsVerifyTempCallback = (childData: boolean) => {
        setState({ ...state, isVerifyTemp: childData });
    }
    const handleLoginErrorCallback = (childData: string) => {
        setState({ ...state, segValue: childData });
    }
    const handleRegisterErrorParentCallback = (childData: boolean) => {
        if (childData) {
            setState({ ...state, segValue: 'register' });
        }
    }
    const handleCloseModalCallback = (childData: boolean) => {
        setState({ ...state, showAuthModal: !childData });
    }
    const handleIsLoginCallback = (childData: boolean) => {
        props.isLoginParentCallback(true);
    }
    const handleIsForgotSubmit = (childData: boolean) => {
        setState({ ...state, isForgotSubmit: childData });
    }
    return (
        <>
            <IonModal isOpen={state.showAuthModal} onDidDismiss={() => setState({ ...state, showAuthModal: false, isVerifyTemp: false, isForgot: false })} mode="ios" cssClass="auth-modal">
                <div className="auth-modal-content">
                    <h3 className="auth-modal-title">
                        ورود / ثبت نام
                        <IonIcon icon={close} onClick={() => setState({ ...state, showAuthModal: false })} />
                    </h3>
                    <div className="auth-modal-items">
                        {(
                            (state.segValue === 'login' && (!state.isForgot && !state.isVerifyTemp)) ||
                            (state.segValue === 'register' && !state.isVerifyTemp)
                        ) &&
                            <IonSegment onIonChange={e => setState({ ...state, segValue: e.detail.value! })} value={state.segValue} className="login-register-segment" mode="ios">
                                <IonSegmentButton value="login">
                                    <IonLabel>ورود</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton value="register">
                                    <IonLabel>ثبت نام</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                        }
                        {state.isForgot ?
                            <>
                                <Forgot
                                    loginErrorParentCallback={handleLoginErrorCallback}
                                    closeModalParentCallback={handleCloseModalCallback}
                                    isLoginParentCallback={handleIsLoginCallback}
                                    isForgotSubmit={handleIsForgotSubmit}
                                />
                                {state.isForgotSubmit &&
                                    <IonButton color="dark" fill="outline" onClick={backToLogin} className="back-to-login">
                                        <IonIcon icon={arrowBack} />
                                    </IonButton>
                                }
                            </>
                            : [
                                (state.segValue === 'login' ?
                                    <React.Fragment key={'ReactFragment'}>
                                        <Login
                                            loginForgotParentCallback={handleLoginForgotParentCallback}
                                            isVerifyTempParentCallback={handleIsVerifyTempCallback}
                                            loginErrorParentCallback={handleLoginErrorCallback}
                                            closeModalParentCallback={handleCloseModalCallback}
                                            isLoginParentCallback={handleIsLoginCallback}
                                        />
                                    </React.Fragment>
                                    :
                                    <React.Fragment key={'ReactFragment'}>
                                        <Register
                                            isVerifyTempParentCallback={handleIsVerifyTempCallback}
                                            registerErrorParentCallback={handleRegisterErrorParentCallback}
                                            closeModalParentCallback={handleCloseModalCallback}
                                            isLoginParentCallback={handleIsLoginCallback}
                                        />
                                    </React.Fragment>
                                )
                            ]
                        }
                    </div>
                </div>
            </IonModal>
            <IonButton color="warning" expand="block" className="auth-btn" onClick={() => setState({ ...state, showAuthModal: true })}>
                ورود / ثبت نام
            </IonButton>
        </>
    );
};
export default Auth;